import { useNavigate } from "react-router-dom";
import EntityPage from "@/components/EntityPage";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { PrivacyBadge } from "@/components/PrivacyCard";

export const CLIENTE_FIELDS = [
  { name: "nome", label: "Nome", required: true },
  { name: "cognome", label: "Cognome" },
  { name: "telefono", label: "Telefono" },
  { name: "email", label: "Email", type: "email" },
  { name: "indirizzo", label: "Indirizzo", full: true },
  { name: "codice_fiscale", label: "Codice fiscale / P.IVA" },
  { name: "note", label: "Note", type: "textarea" },
];

export default function Clienti() {
  const navigate = useNavigate();
  return (
    <EntityPage
      overline="Anagrafica" title="Clienti" endpoint="clienti" prefix="clienti" singular="cliente" newLabel="Nuovo cliente"
      fields={CLIENTE_FIELDS}
      onRowClick={(c) => navigate(`/clienti/${c.id}`)}
      deleteDescription="Verranno eliminate anche le bici del cliente. Non è possibile eliminare clienti con schede di lavoro."
      columns={[
        { key: "nome", label: "Cliente", render: (c) => <span className="font-semibold text-slate-900">{c.nome} {c.cognome}</span> },
        { key: "telefono", label: "Telefono", render: (c) => c.telefono ? <span className="flex items-center gap-2">{c.telefono} <WhatsAppButton compact telefono={c.telefono} testId={`clienti-whatsapp-${c.id}`} /></span> : "—" },
        { key: "email", label: "Email" },
        { key: "indirizzo", label: "Indirizzo" },
        { key: "privacy_firmata", label: "Privacy", render: (c) => <PrivacyBadge c={c} /> },
      ]}
    />
  );
}
